export const PaEInfo = [
  {
    id: 1,
    img: "/Images/Events/Cancer.JPG",
    alt: "Cancer group",
    title: "Cancer Survivor Support Group",
    content: [
      {Info: "The second Friday of each month, meetings offer emotional and educational fellowship for patients, survivors, and care givers."}
    ],
    //Pregnancy bottle info
    img2: "/Images/Events/Bottles.jpg",
    alt2: "Pennington Chapel",
    title2: "Franklin Life Pregnancy Resource Center Inc",
    content2: [
      {Info: "Local charity organization helping to support pregnant individuals and families."},
      {Info: "Charitable donations to provide resources are always welcome."}
    ]
  },
  {
    id: 2,
    img: "/Images/Events/Trip.jpeg",
    alt: "Hinton Trip",
    title: "Annual Mission Trip to Hinton Center",
    content: [
      {Info: "The mission trips are funded by proceeds from our yard sales throughout the year and generous donations."}
    ],
    img2: "/Images/Events/Rainbow Pantry.jpg",
    alt2: "Rainbow Pantry",
    title2: "The Rainbow Pantry of Royston",
    content2: [
      {Info: "Local organization helping to support families in need with scheduled monthly work nights and pantry food giveaway days."},
      {Info: "Volunteers help with food distrubution and pantry organization."},
      {Info: "Charitable donations are always welcome."},
    ],
  },
  {
    id: 3,
    img: "/Images/Events/Yard Sale.jpeg",
    alt: "Pennington Chapel",
    title: "Annual Bazaar and Yard Sales",
    content: [
      {Info: "Bring friends/family and enjoy breakfast, baked goods, crafts, and a yard sale."},
      {Info: "Other yard sales are held throughout the year."}, 
      {Info: "Proceeds fund our projects and missions."}
    ],
    img2: "/Images/Events/Easter Basket.jpg",
    alt2: "Easter baskets",
    title2: "Easter Baskets for Shut-Ins",
    content2: [
      {Info: "Our church family assembles and delivers Easter gift baskets full of useful donated items."},
      {Info: "These baskets put smiles on many faces."}
    ]
  },
  {
    id: 4,
    img: "/Images/Events/Christmas Child.jpg",
    alt: "Christmas Presents",
    title: "Annual Operation Christmas Child",
    content: [
      {Info: "Our church assembles shoe boxes filled with donated items that will be shipped to children in need all over the world."},
    ],
    img2: "/Images/Events/Food Drive.jpg",
    alt2: "Shelves of food",
    title2: "Annual Christmas Food Drive",
    content2: [
      {Info: "Our church collects non-perishable food items that are distributed to local food banks and pantries to help the needs of the community."}
    ]
  },
]